import { FBF_CloudCallable } from '@rabbit/firebase/adapter';

export const nestApiCreateConsumer = FBF_CloudCallable<any, any>(
  'api/consumers|POST'
);

export const nestApiChangeConsumerEmail = (
  consumerId: string,
  email: string,
  sendNotification: boolean,
  tenantLink: string
) => {
  return FBF_CloudCallable<
    { email: string; sendNotification: boolean; tenantLink: string },
    { success: boolean; message: string }
  >(`api/consumers/${consumerId}/change-email|POST`)({
    email,
    sendNotification,
    tenantLink,
  });
};
